import { render } from "./EsquecerSenha.vue?vue&type=template&id=2542435e&scoped=true"
import script from "./EsquecerSenha.vue?vue&type=script&lang=js"
export * from "./EsquecerSenha.vue?vue&type=script&lang=js"

import "./EsquecerSenha.vue?vue&type=style&index=0&id=2542435e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2542435e"]])

export default __exports__